import { render, staticRenderFns } from "./spares.vue?vue&type=template&id=21004b91"
import script from "./spares.vue?vue&type=script&lang=js"
export * from "./spares.vue?vue&type=script&lang=js"
import style0 from "./spares.vue?vue&type=style&index=0&id=21004b91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports